<template>
    <v-container fluid>
        <!-- Page Header -->
        <v-row align="center"
               justify="center"
        >
            <v-col cols="12"
                   md="11"
                   class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Media Library</h1>
                <AddMedia></AddMedia>
            </v-col>
        </v-row>
        <IndexMedia />
        <EditMedia />
        <DeleteMedia />
    </v-container>
</template>

<script>
import AddMedia from '@/views/Admin/MediaLibrary/AddMedia';
import EditMedia from '@/views/Admin/MediaLibrary/EditMedia';
import DeleteMedia from '@/views/Admin/MediaLibrary/DeleteMedia';
import IndexMedia from '@/views/Admin/MediaLibrary/IndexMedia';

export default {
    components: { IndexMedia, DeleteMedia, AddMedia, EditMedia },
};
</script>

<style lang="scss">
.MediaModal {
    min-height: 90vh;

    h1 {
        font-size: 1.1rem !important;
    }

    h2 {
        font-size: 1rem !important;
        margin-bottom: 12px;
    }
}

.MediaModal__header {
    h1 {
        font-size: 1.25rem !important;
        margin: 0 !important;
    }
}

.MediaPanel__heading {
    display: flex;
    flex-flow: row nowrap;
    align-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 18px;

    button + button {
        margin-left: 8px;
    }

    button + span {
        margin-left: 8px;
    }

    span + button {
        margin-left: 8px;
    }
}

.MediaModal__preview {
    margin-bottom: 12px;
}

.FieldSelect__list,
.ProfessionSelect__list {
    list-style: none;
    margin: 0 !important;
    padding: 0 !important;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));

    @media (min-width: 480px) {
        grid-template-columns: repeat(auto-fill, minmax(48%, 1fr));
    }

    @media (min-width: 1440px) {
        grid-template-columns: repeat(auto-fill, minmax(31.333%, 1fr));
    }
}

.FieldSelect__list__item,
.ProfessionSelect__list__item {
    flex: 0 0 100%;
    width: 100%;
    border: 1px solid #cecece;
    border-radius: $border-radius-root;
    padding: 8px 8px 2px;

    .v-input--selection-controls {
        margin: 0 !important;
    }

    .v-messages {
        display: none !important;
    }
}

.FieldLabel {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
}

.FieldLabel__name {
    flex: 0 0 100%;
    width: 100%;
    font-weight: 500;
}

.FieldLabel__location {
    flex: 0 0 100%;
    width: 100%;
    font-size: 0.8rem;
}
</style>
